import cn from 'classnames';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { DropDownIcon } from '@shared/assets';
import { Card, MenuDropdown, MenuItem, useCommonMenu } from '@shared/ui';
import { getErrorMessages } from '@src/library/helpers/events/errorMessages';
import type { IClientForm } from '../../model';
import * as st from './styles.module.scss';

type Props = {
  disabled?: boolean;
  isLoading?: boolean;
};
type GenderValues = '' | 'f' | 'm';
const getDisplayedGender = (value: GenderValues) => {
  switch (value) {
    case 'f': {
      return 'Женский';
    }
    case 'm': {
      return 'Мужской';
    }
    default: {
      return '';
    }
  }
};

export const Gender: React.FC<Props> = ({ disabled, isLoading }): JSX.Element => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const { onClose, onOpen, popperEl, referenceEl, setPopperEl, setReferenceEl } = useCommonMenu();

  const errorMessage = getErrorMessages(errors, ['gender']).join(' ');

  const localFormSave: IClientForm | null = JSON.parse(
    localStorage.getItem('clientEditorFormState')!
  );

  useEffect(() => {
    if (localFormSave !== null && localFormSave.gender)
      setValue('gender', localFormSave.gender, { shouldValidate: true });
  }, []);
  return (
    <fieldset className={st.main}>
      <div className={st.main__header}>
        <h3>Пол</h3>
        <p>{errorMessage}</p>
      </div>
      <div className={st.blocks}>
        <Card className={st.card}>
          <div className={st.wrapper}>
            <Controller
              control={control}
              name="gender"
              render={({ field: { value, onChange, onBlur } }) => (
                <div className={cn(st.gender, (disabled || isLoading) && st.disabled)}>
                  <div
                    id="button-gender"
                    className={cn(
                      st.gender__field,
                      (disabled || isLoading) && st.gender__disabled,
                      !!errors.gender && st.gender__error
                    )}
                    onClick={onOpen}
                    ref={setReferenceEl}
                  >
                    <span>{getDisplayedGender(value)}</span>
                    <div className={st.icon}>
                      <DropDownIcon />
                    </div>
                  </div>
                  <MenuDropdown
                    // disabled={disabled || isLoading}
                    popperEl={popperEl}
                    referenceEl={referenceEl}
                    setPopperEl={setPopperEl}
                    id={'gender'}
                  >
                    <MenuItem
                      // disabled={disabled || isLoading}
                      key={1}
                      onClick={(e) => {
                        onClose(e);
                        onChange('m');
                        // !(disabled || isLoading) && onChange('m');
                      }}
                      onBlur={onBlur}
                      className={st.gender__item}
                    >
                      {'Мужской'}
                    </MenuItem>
                    <MenuItem
                      key={2}
                      onClick={(e) => {
                        onClose(e);
                        onChange('f');
                        // !(disabled || isLoading) && onChange('f');
                      }}
                      onBlur={onBlur}
                      className={st.gender__item}
                    >
                      {'Женский'}
                    </MenuItem>
                  </MenuDropdown>
                </div>
              )}
            />
          </div>
        </Card>
        {/* ))} */}
      </div>
    </fieldset>
  );
};
